import React from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';

function BenifitCard({
  icon,
  title,
  description,
}) {
  return (
    <div className=" w-full flex-flexAuto shadow-sm border border-[#89d8ff] rounded-[11px] bg-[#f8fcff] p-4">
      <div className="bg-white rounded-[11px] p-3 shadow-md inline-flex items-center justify-center mb-3">
        <Image src={icon} width={40} height={40} alt="benifit-icon" className="m-0" />
      </div>
      <h3 className="lg:text-[21px] text-[18px] font-[600] leading-[1.3] mb-3 text-[#282938]">{title}</h3>
      <p className="text-[16px] font-[300] text-[#1c1e53]">{description}</p>
    </div>
  );
}
BenifitCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
export default BenifitCard;
